import apiClient from '../client';
import { FloatingMenuStatus } from '../types/tenants.types';

export interface LoginRequest {
  username: string;
  password: string;
}

export interface LoginResponse {
  tokens: {
    access_token: string;
    refresh_token: string;
    token_type: string;
    expires_in: number;
  };
  user: User;
  requires_2fa?: boolean;
  session_id?: string;
}

export interface Tenant {
  id: string;
  code: string;
  display_name: string;
  default_timezone: string;
}

export interface User {
  id: string;
  tenant_id: string;
  username: string;
  email: string;
  first_name: string;
  last_name: string;
  full_name: string;
  is_active: boolean;
  is_verified: boolean;
  roles: string[];
  created_at?: string;
  floating_menu_status?: FloatingMenuStatus;
  timezone: string | null; // User's personal timezone preference
  tenant: Tenant; // Tenant info with default_timezone
}

export const authService = {
  login: async (credentials: LoginRequest): Promise<LoginResponse> => {
    const { data } = await apiClient.post('/tenants/auth/login', credentials);
    return data;
  },

  logout: async (): Promise<void> => {
    await apiClient.post('/tenants/auth/logout');
  },

  refreshToken: async (refreshToken: string): Promise<LoginResponse> => {
    const { data } = await apiClient.post('/tenants/auth/refresh', {
      refresh_token: refreshToken,
    });
    return data;
  },

  getCurrentUser: async (): Promise<User> => {
    const { data } = await apiClient.get('/tenants/auth/me');
    return data;
  },

  verify2FA: async (
    sessionId: string,
    code: string
  ): Promise<LoginResponse> => {
    const { data } = await apiClient.post('/tenants/auth/verify-2fa', {
      session_id: sessionId,
      code,
    });
    return data;
  },
};
